import axios from "axios";
import { DMI_FINANCE_APIS } from "../config/ApiConfig";

export const fetchPlanList = () =>
  axios(DMI_FINANCE_APIS.GET_PLAN_URL, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });

export const fetchBrandList = () =>
  axios(DMI_FINANCE_APIS.GET_BRAND_LIST_URL, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });

export const saveDmiDetails = (payload) =>
  axios(DMI_FINANCE_APIS.SAVE_DMI_DETAILS_URL, {
    method: "POST",
    data: payload,
    headers: { "Content-Type": "application/json" },
  });

export const sendPaymentRequest = (payload) =>
  axios(DMI_FINANCE_APIS.SEND_DMI_PAYMENT_REQUEST_URL, {
    method: "POST",
    data: payload,
    headers: { "Content-Type": "application/json" },
  });

export const fetchPaymentStatus = (userId) =>
  axios(`${DMI_FINANCE_APIS.GET_DMI_PAYMENT_STATUS_URL}?UserId=${userId}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });

// curl 'https://api.suvidha4u.com/policy-callback' \
// -H 'accept: application/json, text/plain, */*' \
// -H 'accept-language: en-US,en;q=0.9,hi;q=0.8' \
// -H 'authorization: Bearer IERDVjczNjM4WTIzN0RHSERTREZHSENDSTk5ODc0UjczOEU5V0RJSkJFV1lZQ0hE' \
// -H 'content-type: application/json' \
// -H 'origin: http://localhost:3001' \
// -H 'priority: u=1, i' \
// -H 'referer: http://localhost:3001/' \
// -H 'sec-ch-ua: "Google Chrome";v="149", "Chromium";v="149", "Not)A;Brand";v="24"' \
// -H 'sec-ch-ua-mobile: ?0' \
// -H 'sec-ch-ua-platform: "macOS"' \
// -H 'sec-fetch-dest: empty' \
// -H 'sec-fetch-mode: cors' \
// -H 'sec-fetch-site: cross-site' \
// -H 'user-agent: Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/149.0.0.0 Safari/537.36' \
// --data-raw '{"id":"mjuw","imei":"333333333333333","plan_name":"Loss of Mobile-15K"}'
export const sendPolicyCallback = (payload) =>
  axios(DMI_FINANCE_APIS.POLICY_CALLBACK_URL, {
    method: "POST",
    data: payload,
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "Bearer IERDVjczNjM4WTIzN0RHSERTREZHSENDSTk5ODc0UjczOEU5V0RJSkJFV1lZQ0hE",
    },
  });

//   curl --location --request POST 'https://suvidha4u.megadock.in/api/policy-callback' \
// --header 'Authorization: Bearer IERDVjczNjM4WTIzN0RHSERTREZHSENDSTk5ODc0UjczOEU5V0RJSkJFV1lZQ0hE' \
// --header 'Content-Type: application/json' \
// --data-raw '{
//     "id": "MTY5MzE0NTQwMQ==",
//     "imei": "490154203237518",
//     "plan_name": "ABC"
//   }'

// curl 'https://suvidha4u.megadock.in/api/policy-callback' \.
export const sendPolicyCallbackB = (payload) =>
  axios(DMI_FINANCE_APIS.POLICY_CALLBACK_URL_B, {
    method: "POST",
    data: payload,
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "Bearer IERDVjczNjM4WTIzN0RHSERTREZHSENDSTk5ODc0UjczOEU5V0RJSkJFV1lZQ0hE",
    },
  });
